export const LINKS = [
	{
		id: 1,
		name: "Home",
	},
	{
		id: 2,
		name: "About",
	},
	{
		id: 3,
		name: "Resume",
	},
	{
		id: 4,
		name: "Skills",
	},
	{
		id: 5,
		name: "Portfolio",
	},

];
